import api from './api';

export interface AttendeeFollowUpReminder {
  _id: string;
  userId: string;
  attendeePhone: string;
  attendeeName: string;
  attendeeEmail?: string;
  propertyId?: string;
  title: string;
  description?: string;
  reminderTime: string;
  isActive: boolean;
  isRecurring: boolean;
  recurringPattern?: {
    type: 'daily' | 'weekly' | 'monthly';
    interval: number;
    endDate?: string;
  };
  notificationType: 'email' | 'in_app' | 'both';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  createdAt: string;
  updatedAt: string;
}

export interface CreateAttendeeFollowUpReminderData {
  attendeePhone: string;
  attendeeName: string;
  attendeeEmail?: string;
  propertyId?: string;
  title: string;
  description?: string;
  reminderTime: string;
  isRecurring?: boolean;
  recurringPattern?: {
    type: 'daily' | 'weekly' | 'monthly';
    interval: number;
    endDate?: string;
  };
  notificationType?: 'email' | 'in_app' | 'both';
  priority?: 'low' | 'medium' | 'high' | 'urgent';
}

export interface UpdateAttendeeFollowUpReminderData {
  title?: string;
  description?: string;
  reminderTime?: string;
  isActive?: boolean;
  isRecurring?: boolean;
  recurringPattern?: {
    type: 'daily' | 'weekly' | 'monthly';
    interval: number;
    endDate?: string;
  };
  notificationType?: 'email' | 'in_app' | 'both';
  priority?: 'low' | 'medium' | 'high' | 'urgent';
}

const getAttendeeFollowUpReminders = async (
  agencySlug: string,
  filters?: { attendeePhone?: string; isActive?: boolean }
): Promise<AttendeeFollowUpReminder[]> => {
  const params = new URLSearchParams();
  if (filters?.attendeePhone) params.append('attendeePhone', filters.attendeePhone);
  if (filters?.isActive !== undefined) params.append('isActive', String(filters.isActive));

  const res = await api.get<{ success: boolean; data: AttendeeFollowUpReminder[] }>(
    `/agencies/${agencySlug}/attendees/follow-up-reminders?${params.toString()}`
  );
  return res.data.data;
};

const createAttendeeFollowUpReminder = async (
  agencySlug: string,
  data: CreateAttendeeFollowUpReminderData
): Promise<AttendeeFollowUpReminder> => {
  const res = await api.post<{ success: boolean; data: AttendeeFollowUpReminder }>(
    `/agencies/${agencySlug}/attendees/follow-up-reminders`,
    data
  );
  return res.data.data;
};

const updateAttendeeFollowUpReminder = async (
  agencySlug: string,
  reminderId: string,
  data: UpdateAttendeeFollowUpReminderData
): Promise<AttendeeFollowUpReminder> => {
  const res = await api.put<{ success: boolean; data: AttendeeFollowUpReminder }>(
    `/agencies/${agencySlug}/attendees/follow-up-reminders/${reminderId}`,
    data
  );
  return res.data.data;
};

const deleteAttendeeFollowUpReminder = async (
  agencySlug: string,
  reminderId: string
): Promise<void> => {
  await api.delete(`/agencies/${agencySlug}/attendees/follow-up-reminders/${reminderId}`);
};

export default {
  getAttendeeFollowUpReminders,
  createAttendeeFollowUpReminder,
  updateAttendeeFollowUpReminder,
  deleteAttendeeFollowUpReminder,
};
